import React from 'react'
import Link from 'gatsby-link'
import Arrow from '../shared/arrow'
import './drawer.css'
import { Mobile, Desktop, Tablet } from '../../media-queries'
import AngleBracketButton from '../shared/angleBracketButton'
import Logo from '../shared/logo'

const Drawer = props => (
  <div>
    <Desktop>
      <DefaultDrawer {...props} />
    </Desktop>
    <Tablet>
      <MobileDrawer {...props} />
    </Tablet>
    <Mobile>
      <MobileDrawer {...props} />
    </Mobile>
  </div>
)

export default Drawer

const DefaultDrawer = props => (
  <div
    style={{
      background: 'white',
      marginLeft: 'auto',
      marginRight: '2rem',
      width: 250,
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'stretch',
        alignContent: 'stretch',
      }}
    >
      <AngleBracketButton
        style={{
          borderTop: '1px solid rgba(0,0,0,0.1)',
          width: 230,
          marginLeft: 10,
          boxShadow: 'none',
          padding: '1rem',
        }}
        textStyle={{ fontWeight: 400, fontSize: 14, lineHeight: 1 }}
        text={'Student portal'}
        link={'/student-portal'}
      />
      <AngleBracketButton
        style={{
          borderTop: '1px solid rgba(0,0,0,0.1)',
          width: 230,
          marginLeft: 10,
          boxShadow: 'none',
          padding: '1rem',
        }}
        textStyle={{ fontWeight: 400, fontSize: 14, lineHeight: 1 }}
        text={'IMRD universities'}
        link={'/universities'}
      />
      <AngleBracketButton
        style={{
          borderTop: '1px solid rgba(0,0,0,0.1)',
          width: 230,
          marginLeft: 10,
          boxShadow: 'none',
          padding: '1rem',
        }}
        textStyle={{ fontWeight: 400, fontSize: 14, lineHeight: 1 }}
        text={'Student stories'}
        link={'/student-stories'}
      />
      <AngleBracketButton
        style={{
          borderTop: '1px solid rgba(0,0,0,0.1)',
          borderBottom: '1px solid rgba(0,0,0,0.1)',
          width: 230,
          marginLeft: 10,
          boxShadow: 'none',
          padding: '1rem',
        }}
        textStyle={{ fontWeight: 400, fontSize: 14, lineHeight: 1.2 }}
        text={'Learning outcomes<br />& Course content'}
        link={'/learning-outcomes-and-course-content'}
        caretStyle={{ width: 12, marginRight: -2 }}
      />
      <Logo
        style={{
          height: '4rem',
          width: '4rem',
          margin: '1.5rem 1rem .25rem',
          alignSelf: 'flex-end',
        }}
        color={'#f7f7f7'}
      />
      <div
        className="contact"
        onClick={props.toggle}
        style={{
          alignSelf: 'flex-end',
          marginRight: '1.175rem',
          fontSize: 13,
          marginBottom: '.5rem',
        }}
      >
        <a href={'/contact'}>Contact us!</a>
      </div>
    </div>
  </div>
)

const MobileDrawer = props => (
  <div id="drawer">
    <Link className="bold" to="/programme">
      <div onClick={props.toggle}>Programme</div>
    </Link>
    <Link className="bold" to="/application">
      <div onClick={props.toggle}>Application</div>
    </Link>
    <Link className="bold" to="/tuition-and-scholarships">
      <div onClick={props.toggle}>
        Tuition &amp;<br />Scholarships
      </div>
    </Link>
    <ArrowButton route="/student-portal" toggle={props.toggle}>
      Student portal
    </ArrowButton>
    <ArrowButton route="/universities" toggle={props.toggle}>
      IMRD universities
    </ArrowButton>
    <ArrowButton route="/student-stories" toggle={props.toggle}>
      Student stories
    </ArrowButton>
    <Link
      to="/learning-outcomes-and-course-content"
      className="arrow"
      onClick={props.toggle}
    >
      <div className="arrowText alignTop">
        Learning outcomes<br />&amp; Course content
      </div>
      <Arrow className="arrowIcon alignTop" />
    </Link>
    <div className="contact" onClick={props.toggle}>
      <a href={'/contact'}>Contact us!</a>
    </div>
  </div>
)

const ArrowButton = props => (
  <Link to={props.route} className="arrow" onClick={props.toggle}>
    <div className="arrowText">{props.children}</div>
    <Arrow className="arrowIcon" />
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/layout/drawer.js